/**
 * Fair Value Gap (FVG) Statistics — Dashboard Overlay
 *
 * Top-right "FVG STATISTICS" info table, replicating the TradingView
 * panel of the open-source script by algolego. Rows are produced by the
 * indicator (identical wording/colors to Pine's table queue):
 *   FVG STATISTICS | <timeframe>     Sample | <date range>
 *   Confirmed zones | 6016 (-1054 overlap)
 *   Returned to zone | 4904 98.8%
 *   Hit rate (n=4877) | 49.3%        95% interval | 47.9% - 50.7%
 *   Placebo (n=391) | 49%
 *   real - placebo | 0.3%   z 0.34   Entry / barrier | close / 2R 8b
 *
 * Compact panel (default) shows the headline rows; the "Compact panel"
 * indicator setting off reveals the full breakdown.
 *
 * Positioned in the chart's top-right corner (clear of the price scale
 * via the priceScaleWidth prop).
 * CSS prefix: fvg-
 */
import React from "react";
import { FvgDashboard } from "../../indicators/built-in/fvg-statistics";
import "./FvgStatsOverlay.scss";

interface FvgStatsOverlayProps {
  dashboard: FvgDashboard | null;
  priceScaleWidth: number;
  visible: boolean;
}

const FvgStatsOverlay: React.FC<FvgStatsOverlayProps> = ({
  dashboard, priceScaleWidth, visible,
}) => {
  if (!visible || !dashboard || !dashboard.rows || dashboard.rows.length === 0) {
    return null;
  }

  const right = (priceScaleWidth > 0 ? priceScaleWidth : 62) + 14;

  return (
    <div className="fvg-dash" style={{ right }}>
      {dashboard.rows.map((r, i) => (
        <div className={`fvg-row${i === 0 ? " fvg-row--head" : ""}`} key={`${i}-${r.k}`}>
          <span className="fvg-k" title={r.k}>{r.k}</span>
          <span className={`fvg-v fvg-v--${r.c}`} title={r.v}>{r.v}</span>
        </div>
      ))}
    </div>
  );
};

export default FvgStatsOverlay;
